// extracted by mini-css-extract-plugin
export var header = "_tg-1";
export var maskBottom = "_tg-6";
export var maskMiddle = "_tg-7";
export var maskTop = "_tg-5";
export var root = "_tg-0";
export var scrollDownButton = "_tg-3";
export var scrollDownButtonHidden = "_tg-4";
export var viewport = "_tg-2";